<template>
    <span>
        <usuariosedit></usuariosedit>
    </span>
</template>

<script>
import Usuariosedit from '@/components/Cadastro-Usuarios-Editar';

export default {
    name: 'cadusuariosedit',
    components: {
        Usuariosedit
    }
};
</script>